import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import { persistCache } from 'apollo3-cache-persist';
import { WebSocketLink } from '@apollo/client/link/ws';
import { getMainDefinition } from '@apollo/client/utilities';
import {
  ApolloProvider,
  ApolloClient,
  ApolloLink,
  createHttpLink,
  split,
} from '@apollo/client';
import { onError } from '@apollo/client/link/error';
import { setContext } from '@apollo/client/link/context';
import { cache } from './graphql/cache';
import { GET_ERROR_DATA } from './graphql/actions/error.js';

persistCache({
  cache,
  storage: window.localStorage,
  maxSize: false,
});

const uriws =
  process.env.NODE_ENV === 'development'
    ? 'ws://100.100.100.248:4000/graphql'
    : 'wss://api.coscef.nat.cu/graphql';

const uri =
  process.env.NODE_ENV === 'development'
    ? 'http://100.100.100.248:4000/graphql'
    : 'https://api.coscef.nat.cu/graphql';

const wsLink = new WebSocketLink({
  uri: uriws,
  options: {
    reconnect: true,
  },
});

const httpLink = createHttpLink({
  uri: uri,
});

const splitLink = split(
  ({ query }) => {
    const definition = getMainDefinition(query);
    return (
      definition.kind === 'OperationDefinition' &&
      definition.operation === 'subscription'
    );
  },
  wsLink,
  httpLink
);

const authLink = setContext((_, { headers }) => {
  // get the authentication token from local storage if it exists
  const token = localStorage.getItem('token');
  // return the headers to the context so httpLink can read them
  return {
    headers: {
      ...headers,
      authorization: token ? `Bearer ${token}` : '',
      'client-name': 'CoScef [web]',
      'client-version': '1.0.0',
    },
  };
});

function logout() {
  console.log('Work...');
  cache.gc();
  client.cache.reset();
  localStorage.clear();
}

localStorage.removeItem('errorNetwork');

const errorLink = onError(({ graphQLErrors, networkError }) => {
  if (graphQLErrors) {
    // graphQLErrors.map(({ message, code, status }) => {
    //   console.log(`[GraphQL error]: Message: ${message}`);
    //   console.log(`[GraphQL error]: Code: ${code}`);
    //   console.log(`[GraphQL error]: Status: ${status}`);
    //   return null;
    // });
    console.log(`[GraphQL error]: Message: ${graphQLErrors[0].message}`);
    console.log(`[GraphQL error]: Code: ${graphQLErrors[0].code}`);
    console.log(`[GraphQL error]: Status: ${graphQLErrors[0].status}`);
    if (graphQLErrors[0].code === 'UNAUTHENTICATED') {
      console.log('Logged out...');
      logout();
    }
  }

  if (networkError) {
    console.log(`[Network error]: ${networkError}`);
    console.log(`[Network status]: ${networkError.statusCode}`);
    console.log(`[Network message]: ${networkError.message}`);

    if (
      networkError.message === 'NetworkError when attempting to fetch resource.'
    ) {
      // console.log('ok');
      localStorage.setItem('errorNetwork', networkError.message);
      cache.writeQuery({
        query: GET_ERROR_DATA,
        data: {
          getErrorData: {
            isNetworkError: !!localStorage.getItem('errorNetwork'),
          },
        },
      });
    }
  }
});

export const client = new ApolloClient({
  cache,
  link: ApolloLink.from([authLink, errorLink, splitLink]),
  resolvers: {},
  connectToDevTools: process.env.NODE_ENV === 'development',
});

const app = (
  <ApolloProvider client={client}>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </ApolloProvider>
);

ReactDOM.render(
  <React.StrictMode>{app}</React.StrictMode>,
  document.getElementById('root')
);
